import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { Layout } from '@singularsystems/neo-canvas-grid';
import InstrumentsWithMultipleISINCodesReportCriteria from "./InstrumentsWithMultipleISINCodesReportCriteria";
import { Neo } from "@singularsystems/neo-react";
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("InstrumentsWithMultipleISINCodes", { category: MaintenanceReportCategories.DataEnrichmentReports})
export default class InstrumentsWithMultipleISINCodesReport extends Report<InstrumentsWithMultipleISINCodesReportCriteria> {
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)) {
        super(InstrumentsWithMultipleISINCodesReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
            <Neo.GridLayout xxl={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker} >
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
            </Neo.GridLayout>
            </>
        );
    }
    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}